module.exports = new __parcel__URL__("dams-sm.45867707.jpg").toString();